import { Feature, Map, MapBrowserEvent } from "ol";
import { Coordinate } from "ol/coordinate";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { useEffect } from "react";

// While enabled, reports each click on the map along with the point of
// interest under it, if any
export function usePOIClick(
	map: Map | null,
	layer: VectorLayer<VectorSource>,
	enabled: boolean,
	onClick: (coordinate: Coordinate, feature: Feature | null) => void,
) {
	useEffect(() => {
		if (!map || !enabled) return () => {};

		const onSingleClick = (e: MapBrowserEvent<UIEvent>) => {
			const hit = map.forEachFeatureAtPixel(e.pixel, (feature) => feature, {
				layerFilter: (l) => l === layer,
				hitTolerance: 4,
			});
			onClick(e.coordinate, hit instanceof Feature ? hit : null);
		};

		map.on("singleclick", onSingleClick);

		return () => {
			map.un("singleclick", onSingleClick);
		};
	}, [map, layer, enabled, onClick]);
}
